import React from 'react';
import { GoogleOutlined, FacebookOutlined } from '@ant-design/icons';
import "firebase/app";

import { auth } from '../Firebase';
import firebase from 'firebase/app';

const Login = () => {
    return (
      <div id="login-page">
        <div id="login-card">
          <img src="https://i.ibb.co/f0YVjXq/Screen-Shot-2021-05-29-at-1-17-38-PM-removebg-preview.png" alt="Nchat Logo" width="50" height="50" class="center"/>
                <br />
                <h3>Welcome to Nchat App</h3>
          
                <br />
          <div
            className="login-button google"
            onClick={() =>
              auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())
            }
          >
            <GoogleOutlined /> Sign in with Google
          </div>
          <br /> <br />
          <div
            className="login-button facebook"
            onClick={() =>
              auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider())
            }
          >
            <FacebookOutlined /> Sign in with Facebook
          </div>
        </div>
      </div>
    );
}

export default Login;